import { Card, CardContent } from "@/components/ui/card";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { SEOHead } from "@/components/SEOHead";

export default function HealthcareDisclaimer() {
  return (
    <div className="min-h-screen bg-background font-sans text-foreground flex flex-col">
      <SEOHead 
        title="Healthcare Disclaimer | Woods Spine & Wellness"
        description="Important information regarding medical advice provided by Woods Spine & Wellness."
        canonical="https://woodsspine.com/healthcare-disclaimer"
      />
      <Navbar />
      <main className="flex-grow">
        <section className="bg-primary py-16 text-primary-foreground text-center">
          <div className="container mx-auto px-4">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Healthcare Disclaimer</h1>
            <p className="text-xl opacity-90">Important information regarding medical advice.</p>
          </div>
        </section>

        <section className="py-16">
          <div className="container mx-auto px-4 max-w-4xl">
            <Card className="shadow-lg border-0">
              <CardContent className="p-8 md:p-12 prose prose-slate max-w-none">
                <p className="text-lg text-muted-foreground mb-8">
                  The information provided on this website by Woods Spine & Wellness is for general informational purposes only and is not intended or implied to be a substitute for professional medical advice, diagnosis, or treatment.
                </p>

                <h3 className="text-2xl font-bold text-primary mb-4">Not Medical Advice</h3>
                <p className="mb-4">
                  Please do not use the information on this website to diagnose or treat any medical or health condition. All content, including text, graphics, images, and information, contained on or available through this web site is for general information purposes only.
                </p>

                <h3 className="text-2xl font-bold text-primary mb-4">Consult Your Physician</h3>
                <p className="mb-4">
                  You should always consult with a physician or other healthcare professional before making any medical decisions or beginning any new treatment. Never disregard professional medical advice or delay seeking medical treatment because of something you have read on or accessed through this website.
                </p>

                <h3 className="text-2xl font-bold text-primary mb-4">No Patient-Provider Relationship</h3>
                <p className="mb-4">
                  Your use of this website does not establish a doctor-patient relationship between you and Woods Spine & Wellness or any of its practitioners. Information submitted through this website is not considered secure and does not constitute a medical consultation.
                </p>

                <h3 className="text-2xl font-bold text-primary mb-4">Emergencies</h3>
                <p className="mb-4">
                  If you think you may have a medical emergency, call your doctor, go to the emergency department, or call 911 immediately. Woods Spine & Wellness does not recommend or endorse any specific tests, physicians, products, procedures, opinions, or other information that may be mentioned on this website.
                </p>
                
                <p className="mt-8 text-sm text-muted-foreground">
                  By using this website, you agree that you will not hold Woods Spine & Wellness liable for any action you take based on the information provided herein.
                </p>
              </CardContent>
            </Card>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
